import ERRCODES from '@/utils/error-codes'
export default {
  methods: {
    validate (row) {
      const outErrors = []

      const partyOrganizationId = row.partyOrganizationId
      const cardNumber = row.cardNumber
      const lastName = row.lastName
      const firstName = row.firstName
      const patronymic = row.patronymic
      const mobilePhoneNumber = row.mobilePhoneNumber
      const cardNumberMaxLen = 6
      const lastNameMinLen = 3
      const lastNameMaxLen = 100
      const firstNameMinLen = 3
      const firstNameMaxLen = 100
      const patronymicMinLen = 3
      const patronymicMaxLen = 100

      if (!partyOrganizationId) {
        outErrors.push('partyOrganizationId')
      }
      if (cardNumber.length !== cardNumberMaxLen) {
        outErrors.push(ERRCODES.members.cardNumberMaxLen)
      }
      if (lastName.length < lastNameMinLen) {
        outErrors.push(ERRCODES.members.lastNameMinLen)
      } else if (lastName.length > lastNameMaxLen) {
        outErrors.push(ERRCODES.members.lastNameMaxLen)
      }
      if (firstName.length < firstNameMinLen) {
        outErrors.push(ERRCODES.members.firstNameMinLen)
      } else if (firstName.length > firstNameMaxLen) {
        outErrors.push(ERRCODES.members.firstNameMaxLen)
      }
      if (patronymic.length < patronymicMinLen) {
        outErrors.push(ERRCODES.members.patronymicMinLen)
      } else if (patronymic.length > patronymicMaxLen) {
        outErrors.push(ERRCODES.members.patronymicMaxLen)
      }
      if (!/^380\d{9}$/.test(mobilePhoneNumber)) {
        outErrors.push(ERRCODES.members.mobilePhoneNumber)
      }

      return outErrors
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/members/Validate.mixin.js